import type {
    AnchorProtocol,
    BackgroundNoImageProtocol,
    BaseBreakPointProtocol,
    CursorProtocol,
    IconDecorationProtocol,
    VariableADTvalue
} from '../../protocols'
import type { EventsProtocol } from '../../protocols/event'
import { BlockType } from '../Basic'
import { BaseBlock } from './BaseBlock'

export enum AudioVariant {
    voice = 'voice',
    bar = 'bar',
    button = 'button'
}

export interface AudioBlockConfig extends BaseBreakPointProtocol, EventsProtocol, AnchorProtocol {
    /** 音频地址 */
    audioSource?: VariableADTvalue
    /** 组件外观，默认播放条 */
    variant: AudioVariant
    /** 显示音频时长；仅 voice / bar 生效 */
    showDuration: boolean
    /** 循环播放 */
    isLoop: boolean
    /** 预加载 */
    preload: boolean
    /** 自定义播放图标。暂停/播放图标未单独配置时作为两者的回退 */
    icon?: IconDecorationProtocol
    /** 暂停时图标。显式空值表示使用内置默认图标 */
    pausedIcon?: IconDecorationProtocol
    /** 播放时图标。显式空值表示使用内置默认图标 */
    playingIcon?: IconDecorationProtocol
    /** 默认图标颜色 */
    iconColor?: BackgroundNoImageProtocol
    /** 播放中图标颜色 */
    playingIconColor?: BackgroundNoImageProtocol
    cursor?: CursorProtocol
}

export abstract class AudioBlockAbstract extends BaseBlock {
    type = BlockType.audio

    abstract override config: AudioBlockConfig
}
